// extracted by mini-css-extract-plugin
module.exports = {"hazardHint":"CartItemHazardWarning_hazardHint__35187","ghsImageWrap":"CartItemHazardWarning_ghsImageWrap__d26e3","ghsImage":"CartItemHazardWarning_ghsImage__0b7b5"};